export const getInitialFbRecurringReminderValues = date => ({
  type: 'FACEBOOK_RECURRING_REMINDER',
  status: 'draft',
  startDate: date,
  endDate: date,
  notificationFrequency: 'DAILY',
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Facebook Recurring Consent'
        }
      ],
      triggers: [
        {
          type: 'Comments On Post'
        },
        {
          type: 'Match Hashtag',
          value: []
        }
      ],
      platform: 'facebook',
      description: 'Send User Consent - Recurring',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Opt FB User in - Recurring'
        }
      ],
      triggers: [
        {
          type: 'Received Recurring Consent'
        }
      ],
      platform: 'facebook',
      description: 'User opt in - Recurring',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Send Facebook Blast'
        }
      ],
      triggers: [
        {
          type: 'Send at specific time'
        }
      ],
      platform: 'facebook',
      description: 'Send Branded Recurring Blast',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Opt FB User out - Recurring'
        }
      ],
      triggers: [
        {
          type: 'Match Hashtag',
          value: ['#optout']
        }
      ],
      platform: 'facebook',
      description: 'User opt out - Recurring',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-recurring-reminder/create/container/initialValues.js